import { useState } from 'react';

interface UseStackedBarHoverReturn {
  hoveredIndex: number | null;
  handleSegmentHover: (index: number | null) => void;
}

export const useStackedBarHover = (): UseStackedBarHoverReturn => {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  return {
    hoveredIndex,
    handleSegmentHover: setHoveredIndex,
  };
};
